import { useDateField, useDateSegment } from "@react-aria/datepicker";

import PropTypes from "prop-types";
import React from "react";
import { StyledField, StyledSegment } from "./DateRangeField.styles";
import { createCalendar } from "@internationalized/date";
import { useDateFieldState } from "@react-stately/datepicker";
import { useLocale } from "@react-aria/i18n";

function DateSegment({ segment, state, isSmallSize }) {
    const ref = React.useRef();
    const { segmentProps } = useDateSegment(segment, state, ref);

    return (
        <StyledSegment
                {...segmentProps}
                ref={ref}
                isPlaceholder={segment.isPlaceholder || state.value === null}
                isSmallSize={isSmallSize}
            >
                {segment.text}
        </StyledSegment>
    );
}

DateSegment.propTypes = {
    segment: PropTypes.object,
    state: PropTypes.object,
    isSmallSize: PropTypes.bool,
};

export function DateRangeField({ disabled, isSmallSize, ...props }) {
    const { locale } = useLocale();
    const state = useDateFieldState({
        ...props,
        locale,
        createCalendar,
    });

    const ref = React.useRef();
    const { fieldProps } = useDateField(props, state, ref);

    return (
        <StyledField {...fieldProps} ref={ref}>
            {state.segments.map((segment, i) =>
                disabled ? (
                    <StyledSegment
                        key={`${segment.type}-${i}`}
                        disabled={disabled}
                        isPlaceholder={segment.isPlaceholder}
                        isSmallSize={isSmallSize}
                    >
                        {segment.text}
                    </StyledSegment>
                ) : (
                    <DateSegment
                        key={`${segment.type}-${i}`}
                        segment={segment}
                        state={state}
                        isSmallSize={isSmallSize}
                    />
                )
            )}
        </StyledField>
    );
}

DateRangeField.propTypes = {
    disabled: PropTypes.bool,
    isSmallSize: PropTypes.bool,
};
